import AdminTransactions from './AdminTransactions';

export default AdminTransactions;